<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card
          class="elevation-12"
        >
          <v-card-text>
            <v-form
              ref="observer"
              v-model="formValid"
            >
              <v-text-field
                v-model="form.userId"
                :rules="rules.id_rule"
                label="아이디"
                type="text"
              />
              <v-text-field
                v-model="form.userPassword"
                :append-icon="showpwd ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="rules.pwd_rule"
                label="비밀번호"
                :type="showpwd ? 'text' : 'password'"
                @keyup.enter="login"
                @click:append="showpwd = !showpwd"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-checkbox
              v-model="rememberId"
              label="아이디 기억"
            />
            <v-spacer />
            <v-btn
              color="primary"
              @click="login"
            >
              로그인
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="messageDialog" :width="!isMobile? '30%' : ''"
    >
      <v-card
        outlined
      >
        <v-card-title />
        <v-card-text>{{ loginMeg }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="messageDialog = false"
          >
            확인
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { ACCESS_TOKEN, REMEMBER_ID, USER_ID } from '../data'
  import { call, sync } from 'vuex-pathify'
  import DataUtils from '../util/data'

  export default {
    data () {
      return {
        showpwd: false,
        formValid: true,
        formHasErrors: false,
        rememberId: false,
        messageDialog: false,
        isMobile: false,
        loginMeg: '',
        form: {
          userId: '',
          userPassword: '',
        },
        rules: {
          id_rule: [
            v => !!v || '아이디는 필수 입력사항입니다.',
          ],
          pwd_rule: [
            v => !!v || '패스워드는 필수 입력사항입니다.',
          ],
        },
        redirectPath: '/components/TestRequestList',
        redirectMasterPath: '/components/TestRequestMaster',
        backPressedCount: 0,
      }
    },
    computed: {
      ...sync('account', [
        'fcmKey',
        'usePush',
      ]),
      isHome () {
        return true
      },
    },
    created () {
      localStorage.setItem(ACCESS_TOKEN, '')

      this.rememberId = localStorage.getItem(REMEMBER_ID)

      if (this.rememberId) {
        this.form.userId = localStorage.getItem(USER_ID)
      }

      if (DataUtils.isMobile()) {
        window.getAppInfo = this.getAppInfo
        this.isMobile = true
      }
    },
    methods: {
      fetchToken: call('account/fetchToken'),
      setPushKey: call('account/setPushKey'),
      GetUserPushInfo: call('account/GetUserPushInfo'),
      login () {
        this.$refs.observer.validate()

        if (this.formValid) {
          if (this.rememberId) {
            localStorage.setItem(REMEMBER_ID, this.rememberId)
            localStorage.setItem(USER_ID, this.form.userId)
          } else {
            localStorage.removeItem(REMEMBER_ID)
            localStorage.removeItem(USER_ID)
          }

          this.fetchToken(this.form)
            .then((response) => {
              if (response.data.msg == null) {
                this.insertPushKey()
                if (response.data.role === 'ROLE_ADMIN') {
                  this.$router.replace(this.redirectMasterPath)
                } else {
                  this.$router.replace(this.redirectPath)
                }
              } else {
                this.loginMeg = response.data.msg
                this.messageDialog = true
              }
            })
            .catch(e => console.error(e.message))
        }
      },
      insertPushKey () {
        try {
          if (DataUtils.isMobile()) {
            if (DataUtils.isIOS()) {
              window.webkit.messageHandlers.SettingsCallbackHandler.postMessage('func=getAppInfo')
            } else {
              window.Settings.getAppInfo()
            }
          }
        } catch (error) {
          this.fcmKey = 'webtest'
          this.setPushKey({
            pushkey: this.fcmKey,
          }).then(
            this.GetUserPushInfo({
              fcmKey: this.fcmKey,
            }),
          )
        }
      },
      getAppInfo (appInfo) {
        this.appInfo = JSON.parse(appInfo)
        this.fcmKey = this.appInfo.fcmToken
        this.setPushKey({
          pushkey: this.fcmKey,
        }).then(
          this.GetUserPushInfo({
            fcmKey: this.fcmKey,
          }),
        )
      },
    },
  }
</script>

<style>

</style>
